import React from 'react';
import { Button, Typography, Modal, Box, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const DonateModal = ({ isOpen, setIsOpen }) => {
    const handleClose = () => setIsOpen(false);

    return (
        <Modal open={isOpen} onClose={handleClose} sx={{overflow:'scroll',}}>
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper', p: 3, borderRadius: 2, boxShadow: 24, width: 400,
                maxWidth: '90%', '@media (max-width: 600px)': {
                  width: '90%',
                  padding: 2,
                }
            }}>
                <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={handleClose}><CloseIcon /></IconButton>

                <Typography variant="h6" mb={2}>One-time donations</Typography>
                <Button variant="contained" component="a" href="https://buy.stripe.com/4gwdUN9dG7GCd564gg" target="_blank" fullWidth sx={{ mb: 1, backgroundColor:'#263238' }}>Donate $5</Button>
                <Button variant="contained" component="a" href="https://buy.stripe.com/aEU7wp4Xq9OK9SU289" fullWidth sx={{ mb: 1, backgroundColor:'#263238' }}>Donate $10</Button>
                <Button variant="contained" component="a" href="https://buy.stripe.com/8wMdUN9dG6CyghicMO" fullWidth sx={{ mb: 1, backgroundColor:'#263238' }}>Donate $25</Button>
                <Button variant="contained" component="a" href="https://buy.stripe.com/4gw4kd9dGe50e9adQT" fullWidth sx={{ mb: 1, backgroundColor:'#263238' }}>Donate $50</Button>
                <Button variant="contained" component="a" href="https://buy.stripe.com/14kcQJfC47GC0ikfZ2" fullWidth sx={{ mb: 1, backgroundColor:'#263238' }}>Custom</Button>

                <Typography variant="h6" mb={2}>Recurring donations</Typography>
                <Button variant="contained" component="a" href="https://buy.stripe.com/9AQdUN0HabWS1mo4gl" fullWidth sx={{ mb: 1, backgroundColor:'#263238' }}>$60/month</Button>
                <Button variant="contained" component="a" href="https://buy.stripe.com/8wM9Ex89Cf943uwdQW" fullWidth sx={{ mb: 1, backgroundColor:'#263238' }}>$150/month</Button>
            </Box>
        </Modal>
    )
}

export default DonateModal;